//@flow
export const checkboxCustomLabelStyle=(boolFlag:boolean)=>{
    return boolFlag?{width: '100%', color: 'red', fontSize: '12px'}:null;
}

export const checkboxCustomStyle={
    paddingTop: '9px',fontSize: '10px'
}


// WEBPACK FOOTER //
// ./src/components/utils/checkbox.js